var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Elections } from './elections';
import { GraphUtils } from './graph-utils';
import { PropertyVotesModel } from './models/property-votes.model';
import * as i0 from "@angular/core";
// test this too
export function setNodePropertiesFromObject(node, srcObject, props, idKey) {
    if (idKey === void 0) { idKey = 'id'; }
    Object.entries(props).forEach(function (_a) {
        var _b = __read(_a, 2), k = _b[0], v = _b[1];
        var val;
        // get value (from string or function)
        if (typeof v === 'string') {
            val = srcObject[v];
        }
        else if (typeof v === 'function') {
            val = v(srcObject[idKey]);
        }
        // store as boolean or numerical state property
        if (typeof val === 'boolean') {
            node.boolState[k] = val;
        }
        else if (typeof val === 'number') {
            node.numState[k] = val;
        }
        else {
            node[k] = val;
        }
    });
}
// Functions for Querying and Editing BdGraph objects
var BdGraphService = /** @class */ (function () {
    function BdGraphService() {
    }
    // recursively add children to node data
    BdGraphService.prototype.serializeNode = function (graph, graphNode, nodeProperties, includeIf) {
        var _this = this;
        if (nodeProperties === void 0) { nodeProperties = {}; }
        if (includeIf === void 0) { includeIf = function (id) { return true; }; }
        var node = {};
        // id
        node.id = graphNode.id;
        // boolean properties
        Object.entries(graphNode.boolState).forEach(function (_a) {
            var _b = __read(_a, 2), prop = _b[0], value = _b[1];
            if (nodeProperties.hasOwnProperty(prop)) {
                node[prop] = value;
            }
        });
        // number properties
        Object.entries(graphNode.numState).forEach(function (_a) {
            var _b = __read(_a, 2), prop = _b[0], value = _b[1];
            if (nodeProperties.hasOwnProperty(prop)) {
                node[prop] = value;
            }
        });
        // children
        if (graph.successors[graphNode.id]) {
            node.children = [];
            graph.successors[graphNode.id].forEach(function (cid) {
                if (includeIf(cid)) {
                    node.children.push(_this.serializeNode(graph, graph.nodes[cid], nodeProperties, includeIf));
                }
            }, this);
        }
        return node;
    };
    // create voter object holding the state to be propagated up
    // get all union of all siblings
    BdGraphService.prototype.getAllSiblingsFromList = function (graph, targets, inclusive) {
        var siblings = [];
        var i;
        for (i = 0; i < targets.length; i++) {
            this.getSiblings(graph, targets[i], inclusive).forEach(function (_sibling) {
                if (!siblings.includes(_sibling)) {
                    siblings.push(_sibling);
                }
            });
        }
        return siblings;
    };
    // this function must not delete voters[id]
    // but the callsite must have its voters variable updated appropriate to ensure full upward graph sync
    // [voting] propagate votes on all properties on all elections. Valid for TREE graphs only
    BdGraphService.prototype.getElectionResults = function (graph, voters, elections, propSyncMap) {
        var _this = this;
        ///////////////////
        // a refactor delt with chapter serializer and its concerns
        // did not yet refactor engine service concerns.
        // PropertyVotes was refactored to be referentially transparent
        // call site needs to be adjusted
        // did not adjust this call site.
        // tslint:disable-next-line
        var __TEMP_UNTIL_REFACTOR_PropertyVotes = /** @class */ (function (_super) {
            __extends(__TEMP_UNTIL_REFACTOR_PropertyVotes, _super);
            function __TEMP_UNTIL_REFACTOR_PropertyVotes(_propSyncMap, __voters) {
                var _this = _super.call(this) || this;
                Object.entries(_propSyncMap).forEach(function (_a) {
                    var _b = __read(_a, 2), property = _b[0], method = _b[1];
                    _this[property] = { votesFor: [], votesAgainst: [] };
                    Object.entries(__voters).forEach(function (_a) {
                        var _b = __read(_a, 2), voterId = _b[0], vote = _b[1];
                        if (vote[property]) {
                            _this[property].votesFor.push(voterId);
                        }
                        else {
                            _this[property].votesAgainst.push(voterId);
                        }
                    }, _this);
                }, _this);
                return _this;
            }
            return __TEMP_UNTIL_REFACTOR_PropertyVotes;
        }(PropertyVotesModel));
        ///////////////////
        var electionTallies;
        var _voters;
        var properties = Object.keys(propSyncMap);
        var results = [];
        elections.forEach(function (electionId) {
            // complete voters list
            _voters = {};
            GraphUtils.getSuccessors(graph, electionId).forEach(function (id) {
                _voters[id] = voters[id] || Elections.createVoter(properties, GraphUtils.getState(graph, id, properties));
                delete voters[id];
            }, _this);
            // count votes for and against for the relevant properties
            electionTallies = new __TEMP_UNTIL_REFACTOR_PropertyVotes(propSyncMap, _voters);
            // create election result from tallies
            // const er = new ElectionResult(electionId, electionTallies, propSyncMap);
            var er = Elections.buildElectionResult(electionId, electionTallies, propSyncMap);
            results.push(er);
            // register new election as voter for upward propagation
            var _voterstate = {};
            Object.entries(er).forEach(function (_a) {
                var _b = __read(_a, 2), property = _b[0], result = _b[1];
                _voterstate[property] = result.result;
            });
            voters[electionId] = _voterstate;
        }, this);
        return results;
    };
    // [voting] update a graph state record for either whole state or changed state
    BdGraphService.prototype.updateGraphStateRecord = function (graph, graphState, electionResults, properties, wholeState) {
        if (wholeState === void 0) { wholeState = true; }
        electionResults.forEach(function (er) {
            var id = er[properties[0]].id;
            var nodeState = GraphUtils.getState(graph, id, properties);
            var targState = {};
            var needsRecording = false;
            properties.forEach(function (property) {
                if (wholeState || er[property].result !== nodeState[property]) {
                    targState[property] = er[property].result;
                    needsRecording = true;
                }
            });
            if (needsRecording) {
                graphState[id] = targState;
            }
        }, this);
    };
    // #TODO[EM]: FIX create nested data from BdGraph object
    // TODO: remove unused
    // serialize<TNode extends BdGraphNode>(graph: BdGraph<TNode>, nodeProperties: Object = {}, includeIf: IncludeIf = (id) => true ): Object[] {
    //   const serialized = [];
    //   Object.entries(graph.roots).forEach(([nodeId, graphNode]) => {
    //     if (includeIf(nodeId)) {
    //       serialized.push(this.serializeNode(graph, graphNode, nodeProperties, includeIf));
    //     }
    //   }, this);
    //   return serialized;
    // }
    // #TODO[EM]: FIX create a new tree from the current tree
    // TODO: remove unused
    // copy<TNode extends BdGraphNode>(graph: BdGraph<TNode>, nodeProperties: Object = {}, 
    //   includeIf: IncludeIf = (id) => true ): BdGraph<TNode> {
    //     const data = this.serialize(graph, nodeProperties, includeIf);
    //     return this.createFromSrc(data);
    // }
    // add node to the graph
    BdGraphService.prototype.addNode = function (graph, nodeData) {
        if (!graph.nodes[nodeData.id]) {
            graph.nodes[nodeData.id] = nodeData;
        }
    };
    // add node as root
    BdGraphService.prototype.addRootNode = function (graph, nodeData) {
        this.addNode(graph, nodeData);
        var root = GraphUtils.getNode(graph, nodeData.id);
        graph.roots[root.id] = root;
    };
    // returns true if node id exists
    BdGraphService.prototype.nodeExists = function (graph, id) {
        return !!graph.nodes[id];
    };
    // add edge to the graph if source/target nodes exist
    BdGraphService.prototype.addEdge = function (graph, sourceId, targetId) {
        if (this.nodeExists(graph, sourceId) && this.nodeExists(graph, targetId)) {
            // add to successors map
            if (graph.successors[sourceId]) {
                graph.successors[sourceId].push(targetId);
            }
            else {
                graph.successors[sourceId] = [targetId];
            }
            // set depth of target node
            var parentDepth = GraphUtils.getNode(graph, sourceId).getDepth();
            GraphUtils.getNode(graph, targetId).setDepth(parentDepth + 1);
            // set as predecessor (there can be only one)
            graph.predecessors[targetId] = sourceId;
        }
    };
    // return all leaf-node ids
    BdGraphService.prototype.getLeaves = function (graph) {
        var leaves = [];
        Object.entries(graph.nodes).forEach(function (_a) {
            var _b = __read(_a, 2), nodeId = _b[0], node = _b[1];
            if (!graph.successors[nodeId]) {
                leaves.push(nodeId);
            }
        });
        return leaves;
    };
    // return all node ids beneath target node
    BdGraphService.prototype.getDescendants = function (graph, id, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var descendants = [];
        var self = this;
        function stepDown(tid) {
            GraphUtils.getSuccessors(graph, tid).forEach(function (childId) {
                descendants.push(childId);
                stepDown(childId);
            });
        }
        // traverse
        stepDown(id);
        // add self id if inclusive
        if (inclusive) {
            descendants.push(id);
        }
        return descendants;
    };
    // return all leaf-node ids beneath or at the target node
    BdGraphService.prototype.getLeafDescendants = function (graph, id, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var leaves = this.getDescendants(graph, id, inclusive).filter(function (descendantId) {
            return GraphUtils.isLeaf(graph, descendantId);
        });
        if (GraphUtils.isLeaf(graph, id) || inclusive) {
            leaves.push(id);
        }
        return leaves;
    };
    BdGraphService.prototype.getAllLeafDescendants = function (graph, ids) {
        var _this = this;
        var leaves = [];
        ids.forEach(function (id) {
            if (GraphUtils.isLeaf(graph, id)) {
                leaves = __spread(leaves, [id]);
            }
            else {
                leaves = __spread(leaves, _this.getLeafDescendants(graph, id, false));
            }
        });
        // De-dupe
        return leaves
            .sort()
            .reduce(function (result, id) {
            if (result.indexOf(id) < 0) {
                result.push(id);
            }
            return result;
        }, []);
    };
    BdGraphService.prototype.getInverseSelection = function (graph, ids) {
        var descendants = this.getAllLeafDescendants(graph, ids);
        return this.getLeaves(graph)
            .filter(function (leaf) { return descendants.indexOf(leaf) < 0; });
    };
    // return all node ids at the same tree level as target node
    BdGraphService.prototype.getSiblings = function (graph, id, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var parentId = graph.predecessors[id];
        var siblings = [];
        if (!!parentId) {
            // non-root node
            siblings = GraphUtils.getSuccessors(graph, parentId);
        }
        else {
            // root node
            siblings = GraphUtils.getRoots(graph);
        }
        if (!inclusive) {
            var idx = siblings.indexOf(id);
            if (idx >= 0) {
                siblings.splice(idx, 1);
            }
        }
        return siblings;
    };
    // return all ancestor node ids in specified order
    BdGraphService.prototype.getAncestors = function (graph, id, inclusive, order) {
        if (inclusive === void 0) { inclusive = false; }
        if (order === void 0) { order = 'ascending'; }
        var ancestors = inclusive ? [id] : [];
        // walk up the tree
        var _parentId = graph.predecessors[id];
        while (_parentId) {
            ancestors.push(_parentId);
            _parentId = graph.predecessors[_parentId];
        }
        // respect user-specified order.
        // NOTE: reverse() is relatively slow, but for the modest tree-depths we expect (tens rather than hundreds), it should be sufficient.
        if (order === 'descending') {
            ancestors.reverse();
        }
        return ancestors;
    };
    // get node data if it exists, for all ids in list
    BdGraphService.prototype.getNodes = function (graph, targets) {
        var nodes = [];
        targets.forEach(function (id) {
            if (graph.nodes[id]) {
                nodes.push(graph.nodes[id]);
            }
        });
        return nodes;
    };
    // set state on a graph node and return changes
    // engine state and service
    BdGraphService.prototype.setState = function (graph, id, state) {
        var node = GraphUtils.getNode(graph, id);
        var changes = {};
        Object.entries(state).forEach(function (_a) {
            var _b = __read(_a, 2), property = _b[0], value = _b[1];
            if (typeof value === 'boolean' && node.boolState[property] !== value) {
                node.boolState[property] = value;
                changes[property] = value;
            }
            else if (typeof value === 'number' && node.numState[property] !== value) {
                node.numState[property] = value;
                changes[property] = value;
            }
        });
        return changes;
    };
    // synchronize all specified properties on the whole tree according 
    // used by engine state and service
    BdGraphService.prototype.synchronize = function (graph, syncProperties, leafStateMap) {
        var _this = this;
        // get results from upward graph traversal
        var graphStateResults = this.calculateGraphStateMap(graph, syncProperties, leafStateMap);
        // apply state changes to graph
        Object.entries(graphStateResults).forEach(function (_a) {
            var _b = __read(_a, 2), id = _b[0], state = _b[1];
            _this.setState(graph, id, state);
        }, this);
        return graphStateResults;
    };
    // calculate state of all affected leaves via single, full graph traversal
    // only used by serialize-chapter service
    // state of all leaves
    // calculate but do not modify graph BOOLEAN state values via upward voting algorithm
    // used by engine state and service
    BdGraphService.prototype.calculateGraphStateMap = function (graph, syncProperties, leafStateMap, wholeState) {
        if (wholeState === void 0) { wholeState = !leafStateMap; }
        var elections = []; // node-ids on which to next set the state
        var voterState = {}; // node state for voters
        var electionResults = []; // Array of election result objects
        var graphStateRecord = {}; // record of graph state
        // initialize voterState and graphStateRecord
        var _properties = Object.keys(syncProperties);
        var depth = 0;
        if (leafStateMap) {
            // partial graph traversal of modified leaves and their siblings up the tree, only record changes
            Object.entries(leafStateMap).forEach(function (_a) {
                var _b = __read(_a, 2), id = _b[0], leafState = _b[1];
                voterState[id] = Elections.createVoter(_properties, leafStateMap[id]);
                graphStateRecord[id] = __assign({}, voterState[id]);
                depth = Math.max(depth, GraphUtils.getNode(graph, id).getDepth());
            }, this);
        }
        else {
            // full graph traversal from all leaves
            this.getLeaves(graph).forEach(function (id) {
                voterState[id] = Elections.createVoter(_properties, GraphUtils.getNode(graph, id).boolState);
                graphStateRecord[id] = __assign({}, voterState[id]);
                depth = Math.max(depth, GraphUtils.getNode(graph, id).getDepth());
            }, this);
        }
        // hold elections up the tree until we run out
        depth -= 1;
        elections = Elections.getEligibleElections(graph, Object.keys(voterState), depth);
        while (depth >= 0) {
            electionResults = this.getElectionResults(graph, voterState, elections, syncProperties);
            this.updateGraphStateRecord(graph, graphStateRecord, electionResults, _properties, wholeState);
            depth -= 1;
            elections = Elections.getEligibleElections(graph, Object.keys(voterState), depth);
        }
        // return full graph state and the condensed graph state
        return graphStateRecord;
    };
    // [query] get the lowest-depth smallest subset of accessors from list of accessors
    // used by chapters state
    BdGraphService.prototype.filterGraphAccessors = function (graph, accessors) {
        var _this = this;
        // get nodes
        var accessorNodes = this.getNodes(graph, accessors);
        // sort by depth
        var sorted = accessorNodes.sort(function (left, right) { return left.getDepth() - right.getDepth(); });
        // track accessible
        var accessible = new Map();
        var filtered = sorted.filter(function (accessorNode) {
            if (!accessible.has(accessorNode.id)) {
                // register descendants as accessible
                _this.getDescendants(graph, accessorNode.id, true).forEach(function (id) { return accessible.set(id, true); });
                return true;
            }
            else {
                // ignore, node already accessible
                return false;
            }
        });
        return filtered.map(function (node) { return node.id; });
    };
    // [edit] after editing, the depth should be reset 
    // engine service
    BdGraphService.prototype.resetDepth = function (graph) {
        // handle reset of depth
        var _resetDepth = function (id) {
            var depth = 0;
            if (graph.predecessors[id]) {
                depth = GraphUtils.getNode(graph, graph.predecessors[id]).getDepth() + 1;
            }
            GraphUtils.getNode(graph, id).setDepth(depth);
        };
        GraphUtils.depthFirst(graph, _resetDepth);
    };
    // [edit] deep/soft delete a node and its references
    // engine service
    BdGraphService.prototype.deleteNode = function (graph, id, deep) {
        var _this = this;
        if (deep === void 0) { deep = true; }
        if (!this.nodeExists(graph, id)) {
            return;
        }
        // delete node
        delete graph.nodes[id];
        // delete predecssor edges : remove from parent's children
        var predecessor = graph.predecessors[id];
        if (predecessor) {
            delete graph.predecessors[id];
            if (graph.successors[predecessor]) {
                graph.successors[predecessor] = graph.successors[predecessor].filter(function (sid) { return sid !== id; });
            }
        }
        // delete successor edges: remove children (recursively)
        var successors = graph.successors[id];
        if (successors) {
            delete graph.successors[id];
            if (deep) {
                successors.forEach(function (cid) { _this.deleteNode(graph, cid); }, this);
            }
        }
        // delete from root
        if (graph.roots[id]) {
            delete graph.roots[id];
        }
    };
    BdGraphService.prototype.sanitizeNodeID = function (id) {
        var regex = new RegExp(/\|/, 'gi');
        return id.replace(regex, '_');
    };
    // [edit] set a node as a leaf node, return all removed nodes
    // used by engine service
    BdGraphService.prototype.resetAsLeaf = function (graph, id) {
        var toRemove = [];
        if (graph.nodes[id] && !GraphUtils.isLeaf(graph, id)) {
            // get all descendents; these will be removed
            toRemove = this.getDescendants(graph, id);
            // remove descendent nodes from list
            delete graph.successors[id]; // it's a leaf node now
            toRemove.forEach(function (rid) {
                delete graph.nodes[rid];
                delete graph.successors[rid];
                delete graph.predecessors[rid];
            });
        }
        return toRemove;
    };
    // [edit] set a node as a parent to other nodes. Because this is a tree, enforce single-parent condition
    // used by engine service
    BdGraphService.prototype.resetAsParent = function (graph, id, children, replace) {
        var _this = this;
        if (replace === void 0) { replace = false; }
        var targets = id ? GraphUtils.getSuccessors(graph, id) : Object.keys(graph.roots);
        var additions = children.filter(function (cid) { return targets.indexOf(cid) < 0; });
        var subtractions = targets.filter(function (cid) { return children.indexOf(cid) < 0; });
        // detach current parent relationships and reset new parent
        var parentId;
        additions.forEach(function (cid) {
            parentId = graph.predecessors[cid]; // current parent
            // de-root node if necessary
            if (id && graph.roots[cid]) {
                delete graph.roots[cid];
            }
            // remove child from old parent
            if (parentId) {
                var _successors = GraphUtils.getSuccessors(graph, parentId).filter(function (_id) { return _id !== cid; });
                if (_successors.length) {
                    graph.successors[parentId] = _successors;
                }
                else {
                    delete graph.successors[parentId];
                }
            }
            if (id) {
                // re-stitch connections
                graph.predecessors[cid] = id; // set new parent
                graph.successors[id] = __spread(GraphUtils.getSuccessors(graph, id), [cid]);
            }
            else {
                // this is to be root
                delete graph.predecessors[cid];
                graph.roots[cid] = GraphUtils.getNode(graph, cid);
            }
        });
        // if replacing, only the specified child nodes should be children of parent
        if (replace) {
            if (id) {
                graph.successors[id] = children;
            }
            subtractions.forEach(function (sid) { _this.deleteNode(graph, sid); }, this);
        }
        return subtractions;
    };
    // [helper] create a state-map object from a collection property state maps
    BdGraphService.prototype.createGraphStateMapFromPropertyMaps = function (propertyMaps) {
        var _a;
        var result = {};
        // tslint:disable-next-line:forin
        for (var property in propertyMaps) {
            // tslint:disable-next-line:forin
            for (var id in propertyMaps[property]) {
                result[id] = __assign({}, result[id] || {}, (_a = {}, _a[property] = propertyMaps[property][id], _a));
            }
        }
        return result;
    };
    // [helper] extract a property state map from a graph state map object
    BdGraphService.prototype.extractPropertymapFromGraphState = function (graphMap, property) {
        var result = {};
        for (var id in graphMap) {
            if (graphMap[id].hasOwnProperty(property)) {
                result[id] = graphMap[id][property];
            }
        }
        return result;
    };
    BdGraphService.ngInjectableDef = i0.defineInjectable({ factory: function BdGraphService_Factory() { return new BdGraphService(); }, token: BdGraphService, providedIn: "root" });
    return BdGraphService;
}());
export { BdGraphService };
